<template>
  <li class="hover:bg-zinc-300 hover:dark:bg-zinc-800 cursor-pointer">
    <RouterLink class="p-4 block w-full flex items-center justify-between" :to="{ name: 'plan', params: { id: plan.id } }">
      <div>{{ plan.name }}</div>
    </RouterLink>
  </li>
</template>

<script setup>
import { RouterLink } from "vue-router";

defineProps({
  plan: {
    type: Object,
    default: () => {}
  }
})
</script>
